const storePathValues = () => {
  const storage = window?.sessionStorage;
  if (!storage) return;
  // Set the previous path as the value of the current path.
  const prevPath = storage.getItem('currentPath') as string;
  storage.setItem('prevPath', prevPath);
  // Set the current path value by looking at the browser's location object.
  storage.setItem('currentPath', window?.location?.pathname);
};
export default storePathValues;
